import React from "react";

export default function PaymentButton({
  cartGTotal,
  handleSubmit,
  bottleDepositAmount,
  returnBottlesCount,
}) {
  return (
    <div className="mx-auto w-full max-w-lg mt-4">
      <form id="checkout-form" onSubmit={handleSubmit}>
        {cartGTotal < 75 ? (
          <button
            type="button"
            disabled
            className="flex w-full items-center justify-center rounded-md mt-5
            border border-transparent cursor-not-allowed
            bg-darkLight hover:bg-darkLight
            px-6 py-3 text-base font-medium text-textWhite hover:text-cool-gray-700 shadow-sm"
          >
            Pay Your Order {cartGTotal.toFixed(2)} AED
          </button>
        ) : (
          <button
            type="submit"
            className="flex w-full items-center justify-center rounded-md mt-5
            border border-transparent 
            bg-secondary hover:bg-secondaryHover
            px-6 py-3 text-base font-medium text-textWhite hover:text-cool-gray-700 shadow-sm"
          >
            <span>Pay Your Order {cartGTotal.toFixed(2)} AED</span>
          </button>
        )}
      </form>

      {/* Minimum Order Notice */}
      {cartGTotal < 75 && (
        <div className="mt-3 text-center">
          <p className="text-sm text-red-600 font-medium">
            ⚠️ Minimum order amount is 75 AED
          </p>
          <p className="text-xs text-gray-600 mt-1">
            Add {(75 - cartGTotal).toFixed(2)} AED more to proceed
          </p>
        </div>
      )}

      {/* ✅ NEW: Bottle Deposit Info */}
      {bottleDepositAmount > 0 && (
        <div className="mt-3 bg-blue-50 border border-blue-200 rounded-lg p-3">
          <div className="flex items-center justify-between text-sm">
            <div className="flex items-center text-blue-800">
              <svg
                className="w-4 h-4 mr-2"
                fill="currentColor"
                viewBox="0 0 20 20"
              >
                <path
                  fillRule="evenodd"
                  d="M18 10a8 8 0 11-16 0 8 8 0 0116 0zm-7-4a1 1 0 11-2 0 1 1 0 012 0zM9 9a1 1 0 000 2v3a1 1 0 001 1h1a1 1 0 100-2v-3a1 1 0 00-1-1H9z"
                  clipRule="evenodd"
                />
              </svg>
              <span>
                Includes <strong>{bottleDepositAmount.toFixed(2)} AED</strong>{" "}
                refundable deposit
              </span>
            </div>
          </div>
        </div>
      )}

      {/* Continue Shopping Button */}
      <div className="flex mt-8 justify-center md:justify-start">
        <a
          href="/productsrange"
          className="inline-flex items-center justify-center w-full px-5 py-3 mr-3 text-base font-medium text-center 
          text-primary rounded-md border border-1 hover:bg-secondaryVeryLight focus:ring-4 focus:ring-primary-300
          dark:focus:ring-primaryLight"
        >
          Continue to Shop or Modify Your Order
        </a>
      </div>
    </div>
  );
}
